import ExposedAssetVisitList from "."
import { compose } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import moment from "moment"
import gql from "graphql-tag"

const ExposedAssetVisitListEnhanced = compose(
  graphql(
    gql`
      query ContactTracingExposedAssetVisits(
        $assetId: ID!
        $startAt: String!
        $endAt: String!
      ) {
        asset(id: $assetId) {
          id
          assetVisits(startAt: $startAt, endAt: $endAt) {
            edges {
              node {
                id
                entryAt
                exitAt
                location {
                  id
                  name
                }
                unit {
                  id
                  name
                }
              }
            }
          }
        }
      }
    `,
    {
      options: ({ assetId, startAt, endAt }) => ({
        variables: { assetId, startAt, endAt },
      }),
      props: ({ data: { error, loading, asset } }) => {
        if (error) throw error
        if (loading) return { loading }

        return {
          visits: asset.assetVisits.edges.map((edge) => ({
            locationId: edge.node.location.id,
            duration: moment
              .parseZone(edge.node.exitAt)
              .diff(moment.parseZone(edge.node.entryAt)),
            unit: edge.node.unit.name,
            name: edge.node.location.name,
            entryAt: edge.node.entryAt,
            exitAt: edge.node.exitAt,
          })),
        }
      },
    }
  )
)(ExposedAssetVisitList)

export default ExposedAssetVisitListEnhanced
